var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "xmoFilterContent__tooltipContent",
      attrs: { tabindex: "0" },
    },
    [
      _c("span", [_vm._v("\n        " + _vm._s(_vm.groupName) + "\n    ")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.subRegions, function (childCountry, childCountryIndex) {
          return _c("li", { key: `${childCountry.id}--${childCountryIndex}` }, [
            _vm._v("\n            " + _vm._s(childCountry.name) + "\n        "),
          ])
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }